import React from 'react';

// Components
import MuiKpiPaper from '../../../../components/muikpipaper';
// Models
import type { KpiGrid } from '../../../../models/operationsmodels/KpiModels';

interface InventoryProps {
  /** Pre-fetched data for print view — skips Redux read when provided */
  data?: KpiGrid[];
  /** When true, renders all grids flat without tabs or interactive controls */
  isPrintView?: boolean;
}

/**
 * Inventory Component - Wrapper for Inventory KPI display
 */
const Inventory: React.FC<InventoryProps> = ({ data, isPrintView }) => {
  return <MuiKpiPaper cardTitle="Inventory" data={data} isPrintView={isPrintView} />;
};

export default Inventory;
